module.exports = __webpack_public_path__ + "img/desktop/Menus-betmenu/btn-paytable-up@2x.png?0.0.53";